module.exports = __webpack_public_path__ + "static/media/sx.1cf829f8.webp";